import type { TWarehouseTaskType, TWarehouseTaskStatus } from 'api/swagger';
import type { TWhTaskFilterOptions } from './types';

export const whTaskTypeOptions: TWhTaskFilterOptions<TWarehouseTaskType> = [
  { value: 'reloading', label: 'reloading' },
  { value: 'storing', label: 'storing' },
];

export const whTaskStatusOptions: TWhTaskFilterOptions<TWarehouseTaskStatus> = [
  { value: 'waiting', label: 'waiting' },
  { value: 'progress', label: 'progress' },
  { value: 'done', label: 'done' },
  { value: 'cancelled', label: 'cancelled' },
];
